import { useGate } from 'effector-react'
import { useTranslation } from 'react-i18next'
import {
  PersonalData,
  personalDataModel,
} from '~/features/common/User/PersonalData'
import { Container, PageTitle, PageContainer } from '~/shared/ui/Layout'

function UserPersonalData() {
  const { t } = useTranslation()
  useGate(personalDataModel.Gate)

  return (
    <PageContainer title={t('personal data')}>
      <Container isHeader>
        <PageTitle>{t('personal data')}</PageTitle>
      </Container>
      <PersonalData />
    </PageContainer>
  )
}

export default UserPersonalData
